import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import { ITemplateWeek } from 'modules/shift_management/store/internal/models/TemplateWeek'

class TemplateWeek extends Model<ITemplateWeek> {
  constructor(attr: ITemplateWeek) {
    super(attr)
    makeObservable(this, {
      isActive: computed,
    })
  }

  get indexes() {
    return ['template_id', 'archived']
  }

  static urlRoot() {
    return '/shift_management/template_weeks'
  }

  get isActive(): boolean {
    return !this.attributes.archived
  }
}

export default TemplateWeek
